<template>
  <div class="list">
    <v-tabs grow centered v-model="tab">
      <!-- <v-tab>Administrator</v-tab> -->
      <v-tab>Users</v-tab>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-container
            style="min-height: 50vh"
            class="d-flex flex-row justify-center"
          >
            <v-card color="transparent" min-width="100%" flat>
              <v-card-text>
                <v-data-table :headers="headers" :items="users">
                  <template v-slot:[`item.actions`]="{}">
                    <v-menu open-on-hover>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="text-capitalize links"
                          text
                          v-bind="attrs"
                          v-on="on"
                          small
                          ><v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item>
                          <span class="table-exam">
                            <v-icon color="primary" size="">mdi-eye</v-icon>
                            View
                          </span>
                        </v-list-item>
                        <v-divider />
                        <v-list-item>
                          <span class="table-exam">
                            <v-icon color="blue" size=""> mdi-pencil </v-icon>
                            Edit
                          </span>
                        </v-list-item>
                        <v-list-item>
                          <span class="table-exam">
                            <v-icon color="error" size="">delete</v-icon>
                            Delete
                          </span>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-container>
        </v-tab-item>
        <v-tab-item></v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: "administratorList",
  data: function () {
    return {
      tab: null,
    };
  },
  computed: {
    users() {
      return this.$store.getters["Administrator/administratorGetters"]("users");
    },
    headers() {
      return [
        { text: "Name", sortable: true, value: "name" },
        { text: "Email", value: "email" },
        { text: "Actions", value: "actions", sortable: false },
      ];
    },
  },
};
</script>

<style scoped></style>
